var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"root"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.address))]),_c('span',{staticClass:"closeButton",on:{"click":function($event){return _vm.$emit('clear-address')}}},[_c('img',{staticClass:"svg",attrs:{"src":"img/close.svg"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }